import pluralize from "pluralize";

pluralize.addIrregularRule("Code postal", "Codes postaux");



// WEBPACK FOOTER //
// src/configs/pluralize.js